export const Elabels = () => (
  <svg
    width='24'
    height='20'
    viewBox='0 0 24 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.50033 1.66663C4.04009 1.66663 3.66699 2.03972 3.66699 2.49996V6.66663C3.66699 7.12686 4.04009 7.49996 4.50033 7.49996C4.96056 7.49996 5.33366 7.12686 5.33366 6.66663V3.33329H8.66699C9.12723 3.33329 9.50033 2.9602 9.50033 2.49996C9.50033 2.03972 9.12723 1.66663 8.66699 1.66663H4.50033Z'
      fill='currentColor'
    />
    <path
      d='M4.50033 18.3333C4.04009 18.3333 3.66699 17.9602 3.66699 17.5V13.3333C3.66699 12.8731 4.04009 12.5 4.50033 12.5C4.96056 12.5 5.33366 12.8731 5.33366 13.3333L5.33366 16.6666H8.66699C9.12723 16.6666 9.50033 17.0397 9.50033 17.5C9.50033 17.9602 9.12723 18.3333 8.66699 18.3333H4.50033Z'
      fill='currentColor'
    />
    <path
      d='M19.5003 18.3333C19.9606 18.3333 20.3337 17.9602 20.3337 17.5V13.3333C20.3337 12.8731 19.9606 12.5 19.5003 12.5C19.0401 12.5 18.667 12.8731 18.667 13.3333V16.6666H15.3337C14.8734 16.6666 14.5003 17.0397 14.5003 17.5C14.5003 17.9602 14.8734 18.3333 15.3337 18.3333H19.5003Z'
      fill='currentColor'
    />
    <path
      d='M19.5003 1.66663C19.9606 1.66663 20.3337 2.03972 20.3337 2.49996V6.66663C20.3337 7.12686 19.9606 7.49996 19.5003 7.49996C19.0401 7.49996 18.667 7.12686 18.667 6.66663V3.33329L15.3337 3.33329C14.8734 3.33329 14.5003 2.9602 14.5003 2.49996C14.5003 2.03972 14.8734 1.66663 15.3337 1.66663H19.5003Z'
      fill='currentColor'
    />
    <path
      d='M7.00033 9.16663C6.54009 9.16663 6.16699 9.53972 6.16699 9.99996C6.16699 10.4602 6.54009 10.8333 7.00033 10.8333H17.0003C17.4606 10.8333 17.8337 10.4602 17.8337 9.99996C17.8337 9.53972 17.4606 9.16663 17.0003 9.16663H7.00033Z'
      fill='currentColor'
    />
    <path
      d='M9.50033 6.66663C9.50033 6.20639 9.87342 5.83329 10.3337 5.83329H13.667C14.1272 5.83329 14.5003 6.20639 14.5003 6.66663C14.5003 7.12686 14.1272 7.49996 13.667 7.49996H10.3337C9.87342 7.49996 9.50033 7.12686 9.50033 6.66663Z'
      fill='currentColor'
    />
    <path
      d='M10.3337 12.5C9.87342 12.5 9.50033 12.8731 9.50033 13.3333C9.50033 13.7935 9.87342 14.1666 10.3337 14.1666H13.667C14.1272 14.1666 14.5003 13.7935 14.5003 13.3333C14.5003 12.8731 14.1272 12.5 13.667 12.5H10.3337Z'
      fill='currentColor'
    />
  </svg>
)
